import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import dayjs from 'dayjs'
import { Row, Col, Input, Button, Modal } from 'antd'
import { PoweroffOutlined } from '@ant-design/icons'
import { formatMessageNew } from '@/utils/common'
import {
  onScanBarcodeResult,
  setKeyCall,
  getAppData,
  onAppData,
  onReadTagResult,
  onKeyMsg,
  setReadSetting
} from '../../../services/rfEpc'
import { rsoValidate, unitOverdueValidate } from '@/services/rfid/defectiveReturn/defectiveReturn'
import { modalConfirm, modalError } from '../../../utils/modalUtils'
import { clearAuthentication } from '../../../utils/authHelp'

const labelCol = 8
const valueCol = 16
const displayInfo = [
  { key: 'salesOrder', languageKey: 'gledSo' },
  { key: 'upc', languageKey: 'upc' },
  { key: 'scanDate', languageKey: 'scanDate' },
  { key: 'giDate', languageKey: 'giDate' },
  { key: 'toDate', languageKey: 'nikeSubmissionDate' },
  { key: 'productCode', languageKey: 'sku', style: { fontWeight: 'bold' } }
]
let currentInput = 'rso'

const OverdueValidation = () => {
  // const [currentInput, setCurrentInput] = useState('rso')
  const mounting = useRef(false)
  const history = useHistory()
  const rsoInputRef = useRef(null)
  const cartonInputRef = useRef(null)
  const epcInputRef = useRef(null)
  const qrCodeInputRef = useRef(null)
  const readTagResult = useRef([])
  const [showDetail, setShowDetail] = useState(false)
  const [rso, setRso] = useState('')
  const [carton, setCarton] = useState('')
  const [epc, setEpc] = useState('')
  const [qrCode, setQrCode] = useState('')
  const [qrCodeVisible, setQrCodeVisible] = useState(false)
  const [rsoQueryFlag, setRsoQueryFlag] = useState(false)
  const [epcqQueryFlag, setEpcqQueryFlag] = useState(false)
  const [detailInfo, setDetailInfo] = useState({})
  const [scanCount, setScanCount] = useState(0)
  const [overdueStatus, setOverdueStatus] = useState('')
  const [defaultCarton, setDefaultCarton] = useState('')
  const [rsoVerified, setRsoVerified] = useState(false)
  const [productVerified, setProductVerified] = useState(false)
  const [readTagStatus, setReadTagStatus] = useState('idle')
  const [deviceCode, setDeviceCode] = useState('')
  const [noLabelModalVisible, setNoLabelModalVisible] = useState(false)
  const [productValidationType, setProductValidationType] = useState(3)

  useEffect(() => {
    focusRso()
    setReadSetting(1)
    getDeviceInfo()
    onScanBarcodeResult(data => {
      console.log('扫码结果')
      console.log('currentInput', currentInput)
      console.log('data', data)
      switch (currentInput) {
        case 'rso':
          setRso(data)
          setRsoQueryFlag(true)
          changeKeyCall(0)
          break
        case 'qrCode':
          if (!validationQrCode(data)) {
            changeKeyCall(0)
            showQrCodeErrorModal(data)
            return
          }
          setQrCode(data)
          epcOrQrCodePressEnter()
          changeKeyCall(0)
          break
        default:
          break
      }
    })
    onReadTagResult(_data => {
      console.log('Read 的原始结果')
      console.log(_data)
      let resList = []
      if (_data && _data.data) {
        resList = _data.data.map(item => item.tagValue)
      }
      const newArr = [...readTagResult.current, ...resList]
      // 去重
      readTagResult.current = Array.from(new Set(newArr))
      setEpc(readTagResult.current.join(','))
    })
    onKeyMsg(isStart => {
      console.log('Key Msg:', isStart)
      if (['rso', 'qrCode'].includes(currentInput)) return
      if (isStart) {
        console.log('Start Read Tag')
        setReadTagStatus('reading')
        console.log('Read Tag Result:', readTagStatus)
        readTagResult.current = []
      } else {
        console.log('Stop Read Tag')
        setReadTagStatus('idle')
        console.log('Read Tag Result:', readTagStatus)
        if (readTagResult.current.length === 0) return
        getReadTagResult()
        changeKeyCall(0)
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (rsoQueryFlag) validationRso()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rsoQueryFlag])

  useEffect(() => {
    if (epcqQueryFlag) validationProduct()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [epcqQueryFlag])

  // useEffect(() => {
  //   if (!rsoVerified) focusRso()
  //   // eslint-disable-next-line react-hooks/exhaustive-de
  // }, [rsoVerified])

  // useEffect(() => {
  //   if (mounting.current && !productVerified) focusEpc()
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [productVerified])

  useEffect(() => {
    if (!rso) return
    if (qrCodeVisible) {
      focusQrCode()
    } else {
      focusEpc()
    }
  }, [rso, qrCodeVisible])

  const showDeviceError = () => {
    modalConfirm(
      {
        content: formatMessageNew('languageObj.defectiveReturnLocale.deviceError'),
        cancelText: formatMessageNew('languageObj.nsptagLocale.backText'),
        okText: formatMessageNew('languageObj.nsptagLocale.loginText'),
        onCancel: () => {
          history.goBack()
        }
      },
      () => {
        clearAuthentication()
        history.push('/login')
      }
    )
  }

  const getDeviceInfo = async () => {
    onAppData(data => {
      if (!data) {
        showDeviceError()
        return
      }
      const code = data.sn
      if (!code) {
        showDeviceError()
        return
      }
      setDeviceCode(code)
    })
    try {
      await getAppData()
    } catch (error) {
      showDeviceError()
    }
  }

  const getReadTagResult = () => {
    if (readTagResult.current.length > 1) {
      modalError(
        {
          content: formatMessageNew('languageObj.defectiveReturnLocale.readError')
        },
        () => {
          setEpc('')
        }
      )
      return
    }
    const values = readTagResult.current[0]
    setEpc(values)
    setEpcqQueryFlag(true)
  }

  // 更新 扳机事件 0 : 1 : 2 : 3 = ⽆状态 : Rfid读取模式 : 扫描条码模式 : RFIDduqu模式(扣动扳机读取，松开停止)
  const changeKeyCall = async key => {
    try {
      await setKeyCall(key, true)
    } catch (error) {
      console.error('Error overdueValidation setKeyCall:', error)
    }
  }

  const onInputFocus = key => {
    currentInput = key
    console.log('输入框聚焦', key)
    if (['rso', 'qrCode'].includes(key)) changeKeyCall(2)
    if (key === 'epc') changeKeyCall(3)
  }

  // ----- RSO 验证 -----
  const focusRso = () => {
    rsoInputRef && rsoInputRef.current && rsoInputRef.current.focus({ cursor: 'all' })
  }

  const onRsoChange = e => {
    setRso(e.target.value)
  }

  const rsoPressEnter = () => {
    setRsoQueryFlag(true)
  }

  const validationRso = () => {
    mounting.current = true
    setRsoQueryFlag(false)
    rsoValidate(rso)
      .then(res => {
        setShowDetail(true)
        updateDefaultCarton()
        cartonInputRef.current.focus({ cursor: 'all' })
      })
      .catch(error => {
        let str = ''
        const { errorCode } = error || {}
        switch (errorCode) {
          case '401':
            str = 'languageObj.commonLocale.tokenInvalid'
            break
          case '5002':
            str = 'languageObj.defectiveReturnLocale.invalidRso'
            break
          default:
            str = 'languageObj.httpLocale.requestError'
            break
        }
        modalError({
          content: formatMessageNew(str)
        })
      })
  }

  // ----- 箱号 -----
  const updateDefaultCarton = () => {
    setDefaultCarton(`vc-${rso}-${dayjs().unix()}`)
  }

  const onCartonChange = e => {
    setCarton(e.target.value)
  }

  const onCartonPressEnter = () => {
    focusEpc()
  }

  // ----- EPC 验证 -----
  const focusEpc = () => {
    epcInputRef && epcInputRef.current && epcInputRef.current.focus({ cursor: 'all' })
  }

  const onEpcChange = e => {
    setEpc(e.target.value)
  }

  const epcOrQrCodePressEnter = () => {
    setEpcqQueryFlag(true)
  }

  const validationProduct = () => {
    setEpcqQueryFlag(false)
    setRsoVerified(true)
    setProductVerified(true)
    const params = {
      rso,
      cartonSequence: carton || defaultCarton,
      epc,
      qrCode,
      deviceCode,
      type: productValidationType
    }
    unitOverdueValidate(params)
      .then(res => {
        epcValidateCb(res, 'normal')
      })
      .catch(error => {
        if (error.errorCode === '4001') {
          showQrCodeErrorModal(qrCode)
          return
        }
        const status = error.errorCode === '5005' ? 'overdue' : 'unableToValidate'
        epcValidateCb(error, status)
        let str = ''
        const { errorCode } = error || {}
        if (['5001', '5002', '5003', '5004', '5005', '5006'].includes(errorCode)) return
        switch (errorCode) {
          case '401':
            str = formatMessageNew('languageObj.commonLocale.tokenInvalid')
            break
          default:
            str = formatMessageNew('languageObj.httpLocale.requestError')
            break
        }
        modalError({ content: str })
      })
  }

  const epcValidateCb = (res, status) => {
    const resultData = res.resultData || {}
    setOverdueStatus(status)
    Object.keys(resultData).forEach(key => {
      if (key.includes('Date')) {
        const format = key === 'toDate' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss'
        resultData[key] = resultData[key] && dayjs(resultData[key]).format(format)
      }
    })
    setScanCount(resultData.unitScanCount)
    setDetailInfo(resultData)
  }

  const onChangeEpcScanMethod = () => {
    setProductValidationType(qrCodeVisible ? 3 : 4)
    setQrCodeVisible(!qrCodeVisible)
    setQrCode('')
    setEpc('')
  }

  // ----- QR Code -----
  const focusQrCode = () => {
    qrCodeInputRef && qrCodeInputRef.current && qrCodeInputRef.current.focus({ cursor: 'all' })
  }

  const validationQrCode = value => {
    return value && value.toUpperCase().startsWith('HTTPS://QR.NIKE.COM/') && value.length === 33
  }

  const showQrCodeErrorModal = value => {
    const str =
      formatMessageNew('languageObj.defectiveReturnLocale.invalidQRCodeFormat') +
      ': ' +
      value +
      ',' +
      formatMessageNew('languageObj.defectiveReturnLocale.tryAgain')
    modalError({ content: str }, () => {
      console.log('二维码错误')
      focusQrCode()
      setQrCode('')
      setProductVerified(false)
    })
  }
  const onQrCodeChange = e => {
    const value = e.target.value
    console.log(value)
    if (!validationQrCode(value)) return
    setQrCode(value)
  }

  // ---- 操作按钮 ----
  const onNextUnit = () => {
    setProductVerified(false)
    setEpc('')
    setQrCode('')
    setOverdueStatus('')
    setDetailInfo({})
    setQrCodeVisible(false)
    setProductValidationType(3)
    focusEpc()
  }

  const onNextCarton = () => {
    setRsoVerified(false)
    setProductVerified(false)
    setRso('')
    setEpc('')
    setQrCode('')
    setCarton('')
    setDefaultCarton('')
    setDetailInfo({})
    setShowDetail(false)
    setOverdueStatus('')
    setScanCount(0)
    focusRso()
    setQrCodeVisible(false)
    setProductValidationType(3)
  }

  const renderDetailInfo = key => {
    if (key === 'productCode') {
      const { productCode, productSize } = detailInfo
      return `${productCode || ''}${productSize ? `-${productSize}` : ''}`
    }
    return detailInfo[key]
  }

  const addNoLabelProductTag = () => {
    validationProduct()
    hideNoLabelModal()
  }

  const hideNoLabelModal = () => {
    setNoLabelModalVisible(false)
    setProductValidationType(3)
  }

  return (
    <div className="overdue-validation-wrapper">
      {/* 输入信息 */}
      <div style={{ marginBottom: 10 }}>
        <Row type="flex" align="middle" className="input-item rso-input-item">
          <Col span={labelCol}>{formatMessageNew('languageObj.defectiveReturnLocale.rso')}:</Col>
          <Col span={valueCol}>
            <Input
              ref={rsoInputRef}
              disabled={rsoVerified}
              value={rso}
              allowClear
              placeholder={formatMessageNew('languageObj.defectiveReturnLocale.rsoPlaceholder')}
              onFocus={() => onInputFocus('rso')}
              onChange={onRsoChange}
              onPressEnter={rsoPressEnter}
            />
          </Col>
        </Row>
        {showDetail && (
          <>
            <Row type="flex" align="stretch" className="input-item">
              <Col span={labelCol}>{formatMessageNew('languageObj.defectiveReturnLocale.carton')}:</Col>
              <Col span={valueCol}>
                <Input
                  ref={cartonInputRef}
                  disabled={rsoVerified}
                  value={carton}
                  allowClear
                  placeholder={formatMessageNew('languageObj.defectiveReturnLocale.cartonPlaceholder')}
                  onChange={onCartonChange}
                  onFocus={() => onInputFocus('carton')}
                  onPressEnter={onCartonPressEnter}
                />
              </Col>
            </Row>
            {qrCodeVisible ? (
              <Row type="flex" align="middle" className="input-item">
                <Col span={labelCol}>{formatMessageNew('languageObj.defectiveReturnLocale.qrCode')}:</Col>
                <Col span={valueCol}>
                  <Input.TextArea
                    ref={qrCodeInputRef}
                    disabled={productVerified}
                    readOnly
                    value={qrCode}
                    allowClear
                    autoSize
                    style={{ flex: 1 }}
                    placeholder={formatMessageNew('languageObj.defectiveReturnLocale.epcPlaceholder')}
                    onFocus={() => onInputFocus('qrCode')}
                    onChange={onQrCodeChange}
                    onPressEnter={epcOrQrCodePressEnter}
                  />
                </Col>
              </Row>
            ) : (
              <Row type="flex" align="middle" className="input-item">
                <Col span={labelCol}>{formatMessageNew('languageObj.defectiveReturnLocale.epc')}:</Col>
                <Col span={valueCol} style={{ display: 'flex' }}>
                  <Input.TextArea
                    ref={epcInputRef}
                    disabled={productVerified}
                    readOnly
                    value={epc}
                    allowClear
                    autoSize
                    style={{ flex: 1 }}
                    placeholder={formatMessageNew('languageObj.defectiveReturnLocale.epcPlaceholder')}
                    onFocus={() => onInputFocus('epc')}
                    onChange={onEpcChange}
                    onPressEnter={epcOrQrCodePressEnter}
                  />
                  {readTagStatus === 'reading' && <Button type="text" icon={<PoweroffOutlined />} loading />}
                </Col>
              </Row>
            )}
            <div className="button-list" style={{ justifyContent: 'center' }}>
              <div
                className={`switch-btn ${qrCodeVisible ? 'switch-btn-epc' : 'switch-btn-qrCode'}`}
                disabled={productVerified}
                onClick={onChangeEpcScanMethod}
              >
                {`${formatMessageNew('languageObj.defectiveReturnLocale.switchTo')}
                ${qrCodeVisible ? 'RFID EPC' : 'QR Code'}`}
              </div>
            </div>
          </>
        )}
      </div>
      {/* 展示信息 */}
      {showDetail && (
        <>
          <div>
            {displayInfo.map(item => (
              <Row key={item.key} className="display-item">
                <Col
                  span={labelCol}
                  style={item.style && { ...item.style, fontSize: item.key === 'productCode' ? 20 : 14 }}
                >
                  {formatMessageNew(`languageObj.defectiveReturnLocale.${item.languageKey}`)}:
                </Col>
                <Col
                  span={valueCol}
                  style={item.style && { ...item.style, fontSize: item.key === 'productCode' ? 20 : 14 }}
                >
                  {renderDetailInfo(item.key)}
                </Col>
              </Row>
            ))}
            {overdueStatus && (
              <div className={`validation-status ${overdueStatus}`}>
                {formatMessageNew(`languageObj.defectiveReturnLocale.${overdueStatus}`)}
              </div>
            )}
            <div className="scan-count" style={{ fontWeight: 'bold' }}>
              {formatMessageNew(`languageObj.defectiveReturnLocale.unitScanCount`)}: <span>{scanCount}</span>
            </div>
          </div>
          {/* 按钮 */}
          <div className="button-list">
            <Button type="primary" onClick={onNextCarton} className="btn-item" style={{ background: '#6cc909' }}>
              {formatMessageNew(`languageObj.defectiveReturnLocale.nextCarton`)}
            </Button>
            <Button
              type="primary"
              disabled={productVerified}
              onClick={() => setNoLabelModalVisible(true)}
              className="btn-item"
              style={{ background: productVerified ? '#d9d9d9' : '#fcc02a' }}
            >
              {formatMessageNew(`languageObj.defectiveReturnLocale.noLabelProduct`)}
            </Button>
            <Button type="primary" onClick={onNextUnit} className="btn-item" style={{ background: '#3671a3' }}>
              {formatMessageNew(`languageObj.defectiveReturnLocale.nextUnit`)}
            </Button>
          </div>
        </>
      )}
      <Modal open={noLabelModalVisible} closable={false} footer={null}>
        <div className="no-label-modal">
          {/* backgroundColor: '#fcc02a' */}
          {/* type="primary" */}
          <Button
            className="btn-item"
            size="large"
            type={productValidationType === 1 ? 'primary' : undefined}
            style={{ marginBottom: 30, backgroundColor: productValidationType === 1 ? '#fcc02a' : '' }}
            onClick={() => setProductValidationType(1)}
          >
            {formatMessageNew(`languageObj.defectiveReturnLocale.noHangTag`)}
          </Button>
          <Button
            className="btn-item"
            size="large"
            type={productValidationType === 2 ? 'primary' : undefined}
            style={{ marginBottom: 30, backgroundColor: productValidationType === 2 ? '#fcc02a' : '' }}
            onClick={() => setProductValidationType(2)}
          >
            {formatMessageNew(`languageObj.defectiveReturnLocale.noResponse`)}
          </Button>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button className="btn-item" size="large" type="primary" onClick={addNoLabelProductTag}>
              {formatMessageNew(`languageObj.defectiveReturnLocale.confirm`)}
            </Button>
            <Button className="btn-item" size="large" onClick={hideNoLabelModal}>
              {formatMessageNew(`languageObj.defectiveReturnLocale.cancel`)}
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  )
}
export default OverdueValidation
